import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-hidable-container',
  templateUrl: './hidable-container.component.html',
  styleUrls: ['./hidable-container.component.scss']
})
export class HidableContainerComponent implements OnInit {
  @Input() switchId: string;
  @Input() isShowContent = false;
  @Output() isShowContentChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  public onButtonChange(): void {
    this.isShowContent = !this.isShowContent;
    this.isShowContentChange.emit(this.isShowContent);
  }

}
